import { MarginUnit } from '../graphql';

export const marginUnits = [
  {
    label: '%',
    id: MarginUnit.PERCENTAGE,
  },
  {
    label: 'UNITS',
    id: MarginUnit.TONNES,
  },
  {
    label: 'MINMAX',
    id: MarginUnit.MINMAX,
  },
];
